<div class="not-found-wrapper">
  <div class="not-founnd-title">
    {{ "GENERALS.PAGE-NOT-FOUND" | translate }}
  </div>
  <div class="not-founnd-content">
    {{ "GENERALS.SORRY-COULDNT-FIND-PAGE" | translate }}
  </div>
</div>
